import {z} from 'zod';

import {
  RecommendedPriceSourceSchema,
  PurchasePriceDefSupplierSourceSchema,
} from '@dms/api/warehouse';

export const SupplierArticlesAddNewFormSchema = z.object({
  supplierInfo: z.object({
    supplierId: z.string(),
    supplierOrderingNumber: z.string().nullish(),
    supplierBulkPackageQuantity: z.number().nullish(),
    supplierDiscountGroupCode: z.string().nullish(),
    supplierManufacturerName: z.string().nullish(),
    supplierManufacturerCode: z.string().nullish(),
    recommendedPriceWithoutVat: z.number().nullish(),
    recommendedPriceSource: RecommendedPriceSourceSchema.nullish(),
    purchasePriceWithoutVat: z.number().nullish(),
    purchasePriceSource: PurchasePriceDefSupplierSourceSchema.nullish(),
    currency: z.string().nullish(),
  }),
  quantityAndUnitsMapping: z.object({
    supplierQuantity: z.number().positive(),
    supplierUnitId: z.string(),
    warehouseQuantity: z.number().positive(),
    warehouseUnitId: z.string(),
  }),
});

export type SupplierArticlesAddNewForm = z.infer<typeof SupplierArticlesAddNewFormSchema>;
